module.exports = __webpack_public_path__ + "static/media/starIcon.d63346af.svg";